import { FollowService } from '@/service/FollowService'
import Model from './Model'

export enum FollowType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
}

export interface IBaseFollowUser {
  avatar?: string
  bio?: string
  title?: string
  contactId: string
  fullName: string
  lastLogin: string
  slug: string
  _id: string
}
export interface IFollow {
  _id: string
  userId: string
  followingUserId: string
  createdAt: Date
  updatedAt: Date
  followType: FollowType
}

export interface IFollowingUser {
  _id: string
  createdAt: string
  contactId: string
  locationId: string
  following: IBaseFollowUser
}

export interface IFollowerUser {
  _id: string
  createdAt: string
  contactId: string
  locationId: string
  follower: IBaseFollowUser
}

export default class Follow extends Model {
  constructor(payload: IFollow) {
    super(payload, FollowService)
  }

  get id(): string {
    return this._data._id
  }

  get userId(): string {
    return this._data.userId
  }

  get followingUserId(): string {
    return this._data.followingUserId
  }

  get followType(): FollowType {
    return this._data.followType
  }

  set followType(followType: FollowType) {
    this._data.followType = followType
  }

  set userId(userId: string) {
    this._data.userId = userId
  }

  set followingUserId(followingUserId: string) {
    this._data.followingUserId = followingUserId
  }
}
